import { z } from "zod";

const positiveAmountMessage = "a positive amount is required";
const decimalAmountPattern = /^(?:\d+|\d*\.\d+)$/;

const amountInputSchema = z.union([
  z.number(),
  z.string().trim().regex(decimalAmountPattern, {
    message: positiveAmountMessage,
  }),
]);

export const positiveAmountSchema = amountInputSchema
  .transform((value) => (typeof value === "number" ? value : Number(value)))
  .refine((value) => Number.isFinite(value) && value > 0, {
    message: positiveAmountMessage,
  });

export const isValidAmount = (value: unknown): boolean =>
  positiveAmountSchema.safeParse(value).success;

export const assertValidAmount = (value: unknown, field = "amount"): number => {
  const result = positiveAmountSchema.safeParse(value);

  if (!result.success) {
    throw new Error(`Invalid ${field}: a positive amount is required`);
  }

  return result.data;
};
